import { useOnlineStatus } from "@/hooks/useOnlineStatus";

export function RouteFallback() {
	const isOnline = useOnlineStatus();

	return (
		<div className="flex min-h-[200px] items-center justify-center p-6">
			<p className="text-sm text-primary-muted">
				{isOnline ? "Loading…" : "Waiting for network connection…"}
			</p>
		</div>
	);
}
